import { createFeatureSelector, createSelector } from '@ngrx/store';
import { odbUsageLevel4FeatureKey } from '../reducers';
import { IOdbBillUsageLevel4State } from '../reducers/odb-usage-level-4.reducer';

export const selectOdbUsageLevel4 =
  createFeatureSelector<IOdbBillUsageLevel4State>(odbUsageLevel4FeatureKey);

export const selectOdbUsageLevel4ByDocumentReferenceAndIdentifierSelector = (
  documentReference: string,
  billableIdentifierNumber: string
) =>
  createSelector(
    selectOdbUsageLevel4,
    (state) =>
      state.odbUsageLevel4ByDocumentReference[documentReference]?.[
        billableIdentifierNumber
      ]
  );

export const selectOdbUsageLevel4SortingInfo = createSelector(
  selectOdbUsageLevel4,
  (state) => state.sortingInfo
);
